import React from "react";
import { motion } from "framer-motion";

const TeamCard = ({ member, variants }) => {
  if (!member) return null;

  return (
    <motion.div
      className="team-card-item"
      variants={variants}
      whileHover={{ y: -10 }}
    >
      <div className="portrait-box">
        <img
          src={
            member.img || "https://via.placeholder.com/400x500?text=Rift+Nakuru"
          }
          alt={member.name}
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/400x500?text=Photo+Unavailable";
          }}
        />
      </div>

      <div className="details-box">
        <h3 className="member-name">{member.name || "Team Member"}</h3>
        <p className="member-role">{member.role || "Insurance Expert"}</p>

        <div className="action-links">
          <a
            href={member.ln || "#"}
            target="_blank"
            rel="noreferrer"
            className="link-btn"
          >
            LinkedIn
          </a>

          <span className="spacer-dot"></span>

          <a
            href={`mailto:${member.email || "info@riftnakuru.co.ke"}`}
            className="link-btn"
          >
            Contact
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default TeamCard;
